import React from 'react';
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {makeStyles} from "@material-ui/styles";

export default function ModelsTable({models}) {
    const classes = useStyles();

    return (

        <Paper variant="outlined" className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{minWidth: column.minWidth}}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {models.map((row) => {
                            return (
                                <TableRow hover tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column.format ? column.format(value) : value}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

        </Paper>

    );
}


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});


const columns = [
    {
        id: 'name',
        label: 'نام مدل',
        minWidth: 170
    },
    {
        id: 'ram',
        label: 'رم',
        minWidth: 70
    },
    {
        id: 'storage',
        label: 'حافظه',
        minWidth: 70
    },
    {
        id: 'brand',
        label: 'برند',
        minWidth: 120,
        format: (value) => value.name
    },
    {
        id: 'createdAt',
        label: 'اضافه‌شده در',
        minWidth: 120,
        format: (value) => new Intl.DateTimeFormat('fa-IR').format(new Date(value)),
    },
];
